import { ErrorCode } from "./error-utils";

export class ClientError extends Error {
  public code: ErrorCode;

  public constructor(code: ErrorCode) {
    super(`CeloError: error code = ${code}`);
    this.code = code;
  }
}

export const isClientError = (value: unknown): value is ClientError => {
  return value instanceof ClientError;
};
